import App from 'app/app.js';

function LtPasswordValidationDirective(ValidationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$parsers.push(function (viewValue) {
        var valid = !viewValue || ValidationService.validatePassword(viewValue);
        ctrl.$setValidity('ltPassword', valid);
        return valid ? viewValue : undefined;
      });
    }
  };
}

App.directive('ltPassword', ['ValidationService', LtPasswordValidationDirective]);
